import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { StorageUtils } from "utils";

const { REQUEST_CALL_SCRIPT_TRACK_ID } = ServiceConstants;

// Local-only storage key while the feature is mocked. The real backend will
// replace this with a POST (see docs/call-scripts-tracking-backend-proposal.md).
const STORAGE_KEY = "CALL_SCRIPT_TRACKING_EVENTS";

export interface CallScriptTrackingEvent {
  // Which script module was used during the call (null = no script opened).
  moduleId: string | null;
  // End node the agent reached in the script flow.
  endType: "success" | "callback" | "negative" | null;
  clientId: number;
  clientName: string;
  agentId: number | null;
  agentName: string;
  // The call outcome chosen in the widget, linked to the script usage.
  callAction: "success" | "failure" | "resolved" | null;
  successResult: string | null;
  failureResult: string | null;
  occurredAt: string;
}

// Mock tracking: simulate a network round-trip, persist to encrypted localStorage,
// and mirror the result into the service slice so callers can resolve it.
export async function trackCallScriptUsage(event: CallScriptTrackingEvent) {
  const requestId = REQUEST_CALL_SCRIPT_TRACK_ID;

  store.dispatch(start(requestId));
  await new Promise((resolve) => setTimeout(resolve, 150));

  const existing: CallScriptTrackingEvent[] = StorageUtils.getObject(STORAGE_KEY) ?? [];
  const updated = [...existing, event];
  StorageUtils.setObject(STORAGE_KEY, updated);

  store.dispatch(end(new ServiceModel(requestId, { event, count: updated.length })));

  return event;
}

// Helper for debugging / a future admin view — not wired to any UI yet.
export function getTrackedEvents(): CallScriptTrackingEvent[] {
  return StorageUtils.getObject(STORAGE_KEY) ?? [];
}
